import React from 'react'
import {MainContainer, TitleContainer} from './ui/new-order-layout'
import {Header, Icon, Button} from '@thryvlabs/maverick'
import {CancelOrderModal} from '../components/cancel-order-modal'
import {ExitOrderModal} from '../components/exit-order-modal'
import {UpdateAddressModal} from './update-address-modal'
import {ConfirmGoBackModal} from './confirm-go-back-modal'
import {BillingNoticeModal} from './billing-notice-modal'
import {useLocation} from 'react-router'
import {useUserRoles} from '../utils/use-user-roles'

import SkeletonLoader from '../components/skeleton-loader'

function NewOrderLayout({
  currentStep,
  prevStep,
  nextStep,
  showContinueButton,
  showCancelButton,
  isLoading,
  title,
  disableNextButton,
  forceShowContinueButton = false,
  children,
  cancelUrl = '/accounts/my-accounts',
  showUpdateAddressModal,
  selectedCountry,
  accountInfo,
  displayStyle,
  centeredHeader = true,
  style,
  cancelOrder,
  disableUpdateAddressModal,
  disableOpenAddressModal,
  showBackButton = true,
  showModal,
  kickoffApptId,
  creativeApptId,
  thryvSuccessServicesApptId,
  countryISOValue,
  setCreativeConfirmed,
  setOnboardingConfirmed,
  setThryvSuccessServicesConfirmed,
  setOnboardingCallDate,
  setCreativeCallDate,
  setThryvSuccessServicesCallDate,
  order5NUId,
  isCancelOrder5,
  cancelOrder5,
  captureOrderNewUpgrade,
  order5OnboardingApptId,
  order5CreativeApptId,
  order5ThryvSuccessServicesApptId,
  setOrder5CreativeApptId,
  setOrder5OnboardingApptId,
  setOrder5ThryvSuccessServicesApptId,
  isBillingNoticeDisplayed,
  setIsBillingNoticeDisplayed,
  isLinkSent,
  isPaymentDetailsPage,
  handleExitOrder,
}) {
  const {roles} = useUserRoles()

  const displayBillingNoticeModal =
    title === 'Entitlements & Add-Ons' ? true : false
  const paymentDetailsPage = title === 'Payment Details' ? true : false
  const {pathname} = useLocation()
  const isUpgrade = pathname === '/order/upgrade'
  console.log('isUpgrade from new-order-layout is ', isUpgrade)
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center">
        <SkeletonLoader height="50vh" width="85vw" />
      </div>
    )
  }
  return (
    <MainContainer
      style={{
        display: displayStyle || 'grid',
        ...style,
      }}
    >
      <TitleContainer title={title} centeredHeader={centeredHeader}>
        {!cancelOrder && showBackButton && (
          <div
            className={`${centeredHeader && 'ml-4 mt-2'}`}
            style={{position: centeredHeader ? 'absolute' : 'static', left: 0}}
          >
            {showModal ? (
              <ConfirmGoBackModal
                altButton={
                  <Icon
                    type="solid"
                    variant="arrowLeft"
                    className="back__arrow mb-2"
                  />
                }
                prevStep={prevStep}
                kickoffApptId={kickoffApptId}
                creativeApptId={creativeApptId}
                thryvSuccessServicesApptId={thryvSuccessServicesApptId}
                countryISOValue={countryISOValue}
                setCreativeConfirmed={setCreativeConfirmed}
                setOnboardingConfirmed={setOnboardingConfirmed}
                setThryvSuccessServicesConfirmed={
                  setThryvSuccessServicesConfirmed
                }
                setOnboardingCallDate={setOnboardingCallDate}
                setCreativeCallDate={setCreativeCallDate}
                setThryvSuccessServicesCallDate={
                  setThryvSuccessServicesCallDate
                }
                order5NUId={order5NUId}
                captureOrderNewUpgrade={captureOrderNewUpgrade}
                order5OnboardingApptId={order5OnboardingApptId}
                order5CreativeApptId={order5CreativeApptId}
                order5ThryvSuccessServicesApptId={
                  order5ThryvSuccessServicesApptId
                }
                setOrder5CreativeApptId={setOrder5CreativeApptId}
                setOrder5OnboardingApptId={setOrder5OnboardingApptId}
                setOrder5ThryvSuccessServicesApptId={
                  setOrder5ThryvSuccessServicesApptId
                }
              />
            ) : (
              <Icon
                type="solid"
                variant="arrowLeft"
                className="back__arrow mb-2"
                onClick={prevStep}
              />
            )}
          </div>
        )}
        {title && (
          <Header fontWeight="normal" variant="h1">
            {title}
          </Header>
        )}
      </TitleContainer>
      {children}
      {(showContinueButton || showCancelButton) && (
        <div className="button__container mt-5" style={{columnGap: '10px'}}>
          {showCancelButton && (
            <CancelOrderModal
              cancelUrl="/accounts/my-accounts"
              order5NUId={order5NUId}
              isCancelOrder5={isCancelOrder5}
              cancelOrder5={cancelOrder5}
            />
          )}
          {cancelOrder && (
            <CancelOrderModal
              cancelUrl="/accounts/my-accounts"
              order5NUId={order5NUId}
              isCancelOrder5={isCancelOrder5}
              cancelOrder5={cancelOrder5}
              isDisableModal={isLinkSent}
            />
          )}
          {showContinueButton &&
            isUpgrade &&
            !isBillingNoticeDisplayed &&
            displayBillingNoticeModal && (
              <BillingNoticeModal
                setIsBillingNoticeDisplayed={setIsBillingNoticeDisplayed}
                disableModal={disableNextButton}
              />
            )}
          {showContinueButton &&
            (!isUpgrade ||
              isBillingNoticeDisplayed ||
              forceShowContinueButton) &&
            !isPaymentDetailsPage && (
              <Button
                data-testid={'continue-button'}
                variant="primary"
                type="button"
                onClick={nextStep}
                disabled={disableNextButton}
              >
                Continue
              </Button>
            )}
          {showContinueButton &&
            (!isUpgrade || isBillingNoticeDisplayed) &&
            (isLinkSent || isPaymentDetailsPage) && (
              <Button
                data-testid={'continue-button'}
                variant="primary"
                type="button"
                onClick={handleExitOrder}
                disabled={!isLinkSent}
              >
                Exit Order
              </Button>
            )}
          {showUpdateAddressModal && (
            <UpdateAddressModal
              nextStep={nextStep}
              selectedCountry={selectedCountry}
              accountInfo={accountInfo}
              disableUpdateAddressModal={disableUpdateAddressModal}
              disableOpenAddressModal={disableOpenAddressModal}
            />
          )}
        </div>
      )}
      {!showContinueButton &&
        (isBillingNoticeDisplayed || paymentDetailsPage) &&
        roles.includes('PartnerOps') && (
          <div className="button__container mt-5" style={{columnGap: '10px'}}>
            <ExitOrderModal
              cancelUrl={cancelUrl}
              order5NUId={order5NUId}
              isCancelOrder5={isCancelOrder5}
              cancelOrder5={cancelOrder5}
              isExitOrderNameChange={true}
            />
          </div>
        )}
    </MainContainer>
  )
}

export {NewOrderLayout}
